/** A shared paint clock. Subscribers move the cursor and bars without a React render. */
export type ReplayClock = {
  getTime: () => number;
  subscribe: (listener: (time: number) => void) => () => void;
};

export function createReplayClock(initialTime: number) {
  let time = initialTime;
  const listeners = new Set<(time: number) => void>();
  return {
    getTime: () => time,
    subscribe(listener: (time: number) => void) {
      listeners.add(listener);
      return () => { listeners.delete(listener); };
    },
    setTime(next: number) {
      if (next === time) return;
      time = next;
      for (const listener of listeners) listener(time);
    }
  };
}
